import { createWebHistory, createRouter } from "vue-router";

import Home from "@/views/HomeQuestion.vue";
import WhoAreYou from "@/views/WhoAreYou.vue";

import QuestionnaireConfiguration from "@/views/QuestionnaireConfiguration.vue";

//Touriste
import TouristeChoixCalcul from "@/views/touriste/TouristeChoixCalcul.vue";
import Q1BothTourist from "@/views/touriste/Q1Both.vue";
import Q2BothTourist from "@/views/touriste/Q2Both.vue";
//Touriste simple
import Q3SimpleTourist from "@/views/touriste/simple/Q3Simple.vue";
import Q4SimpleTourist from "@/views/touriste/simple/Q4Simple.vue";
import Q5SimpleTourist from "@/views/touriste/simple/Q5Simple.vue";
//Touriste detail
import Q3DetailleTourist from "@/views/touriste/details/Q3Detaille.vue";
import Q4DetailleTourist from "@/views/touriste/details/Q4Detaille.vue";
import Q5DetailleTourist from "@/views/touriste/details/Q5Detaille.vue";
import Q6DetailleTourist from "@/views/touriste/details/Q6Detaille.vue";
//Évenement
import EvenementChoixCalcul from "@/views/evenement/EvenementChoixCalcul.vue";
//Évenement simple
import EvenementQ1Simple from "@/views/evenement/simple/Q1Simple.vue";
import EvenementQ2Simple from "@/views/evenement/simple/Q2Simple.vue";
//Évènement detaillee
import EvenementQ1Detaillee from "@/views/evenement/details/Q1Detaillee.vue";
import EvenementQ2Detaillee from "@/views/evenement/details/Q2Detaillee.vue";
import EvenementQ3Detaillee from "@/views/evenement/details/Q3Detaillee.vue";
import EvenementQ3DetailleeOptionA from "@/views/evenement/details/Q3DetailleeOptionA.vue";
import EvenementQ3DetailleeOptionB from "@/views/evenement/details/Q3DetailleeOptionB.vue";
import EvenementQ4Detaillee from "@/views/evenement/details/Q4Detaillee.vue";
import EvenementQ4DetailleeOptionA from "@/views/evenement/details/Q4DetailleeOptionA.vue";
import EvenementQ4DetailleeOptionB from "@/views/evenement/details/Q4DetailleeOptionB.vue";
import EvenementQ5Detaillee from "@/views/evenement/details/Q5Detaillee.vue";
import EvenementQ5DetailleeOptionA from "@/views/evenement/details/Q5DetailleeOptionA.vue";
import EvenementQ5DetailleeOptionB from "@/views/evenement/details/Q5DetailleeOptionB.vue";
import EvenementQ6Detaillee from "@/views/evenement/details/Q6Detaillee.vue";
import EvenementQ6DetailleeOptionA from "@/views/evenement/details/Q6DetailleeOptionA.vue";
import EvenementQ6DetailleeOptionB from "@/views/evenement/details/Q6DetailleeOptionB.vue";
import EvenementQ7Detaillee from "@/views/evenement/details/Q7Detaillee.vue";
import EvenementQ8Detaillee from "@/views/evenement/details/Q8Detaillee.vue";

//Citoyen
import CitoyenChoixCalcul from "@/views/citoyen/CitoyenChoixCalcul.vue";
//Citoyen simple
import Q1SimpleCitoyen from "@/views/citoyen/simple/Q1Simple.vue";
import Q2SimpleCitoyen from "@/views/citoyen/simple/Q2Simple.vue";
import Q3SimpleCitoyen from "@/views/citoyen/simple/Q3Simple.vue";

//Citoyen detaille
import Q1DetailleCitoyen from "@/views/citoyen/details/Q1Detaille.vue";
import Q2DetailleCitoyen from "@/views/citoyen/details/Q2Detaille.vue";
import Q3DetailleCitoyen from "@/views/citoyen/details/Q3Detaille.vue";
import Q4DetailleCitoyen from "@/views/citoyen/details/Q4Detaille.vue";
import Q5DetailleCitoyen from "@/views/citoyen/details/Q5Detaille.vue";
import Q6DetailleCitoyen from "@/views/citoyen/details/Q6Detaille.vue";
import Q7DetailleCitoyen from "@/views/citoyen/details/Q7Detaille.vue";

//Organisation
import OrganisationChoixCalcul from "@/views/organisation/OrganisationChoixCalcul.vue";
import DomaineActivite from "@/views/organisation/DomaineActivite.vue";
//Organisation simple
import Q1SimpleOrganisation from "@/views/organisation/simple/Q1Simple.vue";
import Q2SimpleOrganisation from "@/views/organisation/simple/Q2Simple.vue";
import Q3SimpleOrganisation from "@/views/organisation/simple/Q3Simple.vue";
//Organisation detaille
import Q1DetailleOrganisation from "@/views/organisation/details/Q1Detaille.vue";
import Q2DetailleOrganisation from "@/views/organisation/details/Q2Detaille.vue";
import Q3DetailleOrganisationOptionA from "@/views/organisation/details/Q3DetailleOptionA.vue";
import Q3DetailleOrganisationOptionB from "@/views/organisation/details/Q3DetailleOptionB.vue";
import Q4DetailleOrganisation from "@/views/organisation/details/Q4Detaille.vue";
import Q5DetailleOrganisation from "@/views/organisation/details/Q5Detaille.vue";
import Q6DetailleOrganisation from "@/views/organisation/details/Q6Detaille.vue";
import Q7DetailleOrganisation from "@/views/organisation/details/Q7Detaille.vue";
import Q8DetailleOrganisation from "@/views/organisation/details/Q8Detaille.vue";

//Result
import QuestionnaireResults from "@/views/QuestionnaireResults.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/qui-etes-vous",
    name: "WhoAreYou",
    component: WhoAreYou,
  },
  {
    path: "/touriste",
    children: [
      {
        path: "choix-calcul",
        component: TouristeChoixCalcul,
      },
      {
        path: "simple",
        children: [
          {
            path: "question-1",
            component: Q1BothTourist,
          },
          {
            path: "question-2",
            component: Q2BothTourist,
          },
          {
            path: "question-3",
            component: Q3SimpleTourist,
          },
          {
            path: "question-4",
            component: Q4SimpleTourist,
          },
          {
            path: "question-5",
            component: Q5SimpleTourist,
          },
        ],
      },
      {
        path: "detaille",
        children: [
          {
            path: "question-1",
            component: Q1BothTourist,
          },
          {
            path: "question-2",
            component: Q2BothTourist,
          },
          {
            path: "question-3",
            component: Q3DetailleTourist,
          },
          {
            path: "question-4",
            component: Q4DetailleTourist,
          },
          {
            path: "question-5",
            component: Q5DetailleTourist,
          },
          {
            path: "question-6",
            component: Q6DetailleTourist,
          },
        ],
      },
    ],
  },
  {
    path: "/evenement",
    children: [
      {
        path: "choix-calcul",
        component: EvenementChoixCalcul,
      },
      {
        path: "simple",
        children: [
          {
            path: "question-1",
            component: EvenementQ1Simple,
          },
          {
            path: "question-2",
            component: EvenementQ2Simple,
          },
        ],
      },
      {
        path: "detaille",
        children: [
          {
            path: "question-1",
            component: EvenementQ1Detaillee,
          },
          {
            path: "question-2",
            component: EvenementQ2Detaillee,
          },
          {
            path: "question-3",
            component: EvenementQ3Detaillee,
          },
          {
            path: "question-3-option-a",
            component: EvenementQ3DetailleeOptionA,
          },
          {
            path: "question-3-option-b",
            component: EvenementQ3DetailleeOptionB,
          },
          {
            path: "question-4",
            component: EvenementQ4Detaillee,
          },
          {
            path: "question-4-option-a",
            component: EvenementQ4DetailleeOptionA,
          },
          {
            path: "question-4-option-b",
            component: EvenementQ4DetailleeOptionB,
          },
          {
            path: "question-5",
            component: EvenementQ5Detaillee,
          },
          {
            path: "question-5-option-a",
            component: EvenementQ5DetailleeOptionA,
          },
          {
            path: "question-5-option-b",
            component: EvenementQ5DetailleeOptionB,
          },
          {
            path: "question-6",
            component: EvenementQ6Detaillee,
          },
          {
            path: "question-6-option-a",
            component: EvenementQ6DetailleeOptionA,
          },
          {
            path: "question-6-option-b",
            component: EvenementQ6DetailleeOptionB,
          },
          {
            path: "question-7",
            component: EvenementQ7Detaillee,
          },
          {
            path: "question-8",
            component: EvenementQ8Detaillee,
          },
        ],
      },
    ],
  },
  {
    path: "/citoyen",
    children: [
      {
        path: "choix-calcul",
        component: CitoyenChoixCalcul,
      },
      {
        path: "simple",
        children: [
          {
            path: "question-1",
            component: Q1SimpleCitoyen,
          },
          {
            path: "question-2",
            component: Q2SimpleCitoyen,
          },
          {
            path: "question-3",
            component: Q3SimpleCitoyen,
          },
        ]
      },
      {
        path: "detaille",
        children: [
          {
            path: "question-1",
            component: Q1DetailleCitoyen,
          },
          {
            path: "question-2",
            component: Q2DetailleCitoyen,
          },
          {
            path: "question-3",
            component: Q3DetailleCitoyen,
          },
          {
            path: "question-4",
            component: Q4DetailleCitoyen,
          },
          {
            path: "question-5",
            component: Q5DetailleCitoyen,
          },
          {
            path: "question-6",
            component: Q6DetailleCitoyen,
          },
          {
            path: "question-7",
            component: Q7DetailleCitoyen,
          },
        ]
      }
    ]
  },
  {
    path: "/organisation",
    children: [
      {
        path: "choix-calcul",
        component: OrganisationChoixCalcul,
      },
      {
        path: "domaine-activite",
        component: DomaineActivite,
      },
      {
        path: "simple",
        children: [
          {
            path: "question-1",
            component: Q1SimpleOrganisation,
          },
          {
            path: "question-2",
            component: Q2SimpleOrganisation,
          },
          {
            path: "question-3",
            component: Q3SimpleOrganisation,
          }
        ]
      },
      {
        path: "detaille",
        children: [
          {
            path: "question-1",
            component: Q1DetailleOrganisation,
          },
          {
            path: "question-2",
            component: Q2DetailleOrganisation,
          },
          {
            path: "question-3-option-a",
            component: Q3DetailleOrganisationOptionA,
          },
          {
            path: "question-3-option-b",
            component: Q3DetailleOrganisationOptionB,
          },
          {
            path: "question-4",
            component: Q4DetailleOrganisation,
          },
          {
            path: "question-5",
            component: Q5DetailleOrganisation,
          },
          {
            path: "question-6",
            component: Q6DetailleOrganisation,
          },
          {
            path: "question-7",
            component: Q7DetailleOrganisation,
          },
          {
            path: "question-8",
            component: Q8DetailleOrganisation,
          }
        ]
      }
    ]
  },
  {
    path: "/resultats",
    name: "QuestionnaireResults",
    component: QuestionnaireResults,
  },
  {
      path: "/questionnaire/:who/:level?/:question?",
      name: "Questionnaire",
      component: QuestionnaireConfiguration,
  }
];

const router = createRouter({
  history: createWebHistory('/calculateur-carbone-eclore/'), // Set the base path
  routes,
});

export default router;
